<router-outlet></router-outlet>

<app-modal></app-modal>
<app-toast></app-toast>